const { getAccessToken: getToken } = require("../../client/auth/Auth.js");

export function getAccessToken(): Promise<string> {
  return getToken();
}
